import React, { useState, useRef, useEffect } from 'react';
import { Alert, Card, Col, Container, Input, Label, Row, Button, Modal, ModalBody } from 'reactstrap';
import axios from 'axios';
import Webcam from "react-webcam";
// import ReCAPTCHA from 'react-google-recaptcha'
import ReactInputVerificationCode from 'react-input-verification-code';
import { useInterval } from "usehooks-ts";

import logoTelkom from "../../../assets/images/telkom/logoACI.png";
import Welcome from "../../../assets/images/telkom/welcomeNew.png";

const CoverSignIn = () => {
    const webcamRef = useRef(null);
    sessionStorage.setItem('ex', 0)

    document.title = "Login";

    const [kode, setKode] = useState('');
    const [errorKode, setErrorKode] = useState('');
    const [email, setEmail] = useState('');
    const [errorEmail, setErrorEmail] = useState('');
    const [errorSubmit, setErrorSubmit] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorSubmitKonten, setErrorSubmitKonten] = useState(true);
    const [kontenError, setKontenError] = useState('');
    const [errorOTP, setErrorOTP] = useState(true);
    const [errorMessageOTP, setErrorMessageOTP] = useState('');
    const [sambutan, setSambutan] = useState(true);

    const [disablerChoose, setDisablerChoose] = useState(false);
    const [cameras, setCameras] = useState([]);
    const [mics, setMics] = useState([]);
    const [selectedCameraId, setSelectedCameraId] = useState("");
    const [selectedMicId, setSelectedMicId] = useState("");

    const [bersuara, setBersuara] = useState(true);

    // --- NO DOUBLE CLICK ! --- //
    const [isDouble, setIsDouble] = useState(false)

    // --- OTP After Login --- //
    const [otp, setOTP] = useState('');

    // --- Open MODAL OTP After Login --- //
    const [modalOTP, setModalOTP] = useState(false);

    // --- Get Data After Login --- //
    const [userID, setUserID] = useState("");
    const [idEvent, setIDEvent] = useState("");
    const [emailEncrypt, setEmailEncrypt] = useState("");
    const [namaEncrypt, setNamaEncrypt] = useState("");

    // ReCAPTCHA
    // const captchaRef = useRef(null)

    // --------- MODAL ----------- //
    // const [modalWarning, setModalWarning] = useState(false);
    // const [modalReCAPTCHA, setModalReCAPTCHA] = useState(false);

    const changeKode = (event) => {
        const value = event.target.value
        setKode(value)
        if (!value) {
            setErrorKode('Maaf, kode tidak boleh kosong!')
        } else {
            setErrorKode('')
        }
    }
    const changeEmail = (event) => {
        const value = event.target.value
        setEmail(value)
        if (!value) {
            setErrorEmail('Maaf, Email tidak boleh kosong!')
        } else {
            setErrorEmail('')
        }
    }

    const [modalLimitLogin, setModalLimitLogin] = useState(false)

    // -- Fungsi Get Error Message dari Error Code -- //
    const getErrorMessage = (errorCode) => {
        switch (errorCode) {
            case "E1":
                return "Sesi Anda telah berakhir. Silakan login kembali.";
            case "CE1":
            case "CE2":
                return "Data tidak valid. Silakan periksa kembali.";
            case "IF1":
                return "Data yang diminta tidak tersedia.";
            case "CE3":
                return "Kode tidak dapat digunakan.";
            case "SE1":
                return "Email tidak dapat digunakan.";
            case "PM1":
                return "Email atau password tidak valid.";
            case "PM2":
                return "Konfirmasi password tidak sesuai.";
            case "IF2":
                return "Data tidak lengkap.";
            case "EF1":
                return "Permintaan tidak dapat diproses.";
            case "OM1":
                return "Kode verifikasi tidak valid.";
            case "NC1":
                return "Konfirmasi password tidak sesuai.";
            case "AP1":
                return "Terjadi kesalahan sistem. Silakan coba kembali.";
            case "EX1":
                return "File tidak dapat diproses.";
            case "NX1":
                return "File belum dipilih.";
            case "AK1":
                return "Akses tidak valid.";
            case "FS1":
                return "Ukuran file melebihi batas maksimum yang diizinkan.";
            case "SQ1":
                return "Terjadi kesalahan sistem. Silakan coba kembali.";
            case "MN1":
                return "Gagal memproses file. Silakan coba kembali.";
            case "EV1":
                return "Data yang dikirim tidak valid.";
            case "NM1":
                return "Gagal mengirim notifikasi. Silakan coba kembali.";
            case "RL1":
                return "Terlalu banyak permintaan. Silakan coba kembali beberapa saat lagi.";
            default:
                return errorCode;
        }
    }

    const loginKode = () => {
        setErrorSubmitKonten(true)
        setIsDouble(true)

        // if (captchaRef.current.getValue() !== "") {
        const data = JSON.stringify({
            "email": email,
            "kode": kode
        });

        const config = {
            method: 'patch',
            url: `${process.env.REACT_APP_BASE_ENDPOINT_BACKEND}/peserta/login`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(config)
            .then(function (response) {
                const status = response.status
                console.log(response)
                
                // Check if response contains error code
                if (response.data && response.data.error) {
                    const errorCode = response.data.error;
                    const message = getErrorMessage(errorCode);
                    setErrorMessage(message);
                    setErrorSubmit(false);
                    setTimeout(() => {
                        setErrorSubmit(true)
                        setErrorMessage('')
                    }, 5000)
                    setIsDouble(false)
                    return;
                }

                if (status === 310) {
                    setKontenError("Interview Telah Berakhir")
                    setErrorSubmitKonten(false)
                    setTimeout(() => {
                        setErrorSubmitKonten(true)
                    }, 3000)
                }
                if (status === 311) {
                    setKontenError("Interview Belum Di Mulai")
                    setErrorSubmitKonten(false)
                    setTimeout(() => {
                        setErrorSubmitKonten(true)
                    }, 3000)
                }
                if (status === 401) {
                    setKontenError("Kode sudah digunakan")
                    setErrorSubmitKonten(false)
                    setTimeout(() => {
                        setErrorSubmitKonten(true)
                    }, 3000)
                }
                if (status === 200) {
                    // sessionStorage.setItem('user', JSON.stringify(response.data))
                    // window.location.href = '/p2'

                    if (response && response.data) {
                        let emailEnc = response.data.email;
                        let userId = response.data.id;
                        let namaEnc = response.data.nama;
                        let idEvnt = response.data.id_Event

                        setUserID(userId)
                        setEmailEncrypt(emailEnc)
                        setNamaEncrypt(namaEnc)
                        setIDEvent(idEvnt)

                        // Reset error states
                        setErrorOTP(true);
                        setErrorMessageOTP('');
                        setOTP('');

                        setModalOTP(true)
                    }

                }
                // console.log(response)
                setIsDouble(false)

            })
            .catch(function (error) {
                console.log("/peserta/login", error)
                setIsDouble(false)
                
                if (error.response && error.response.data && error.response.data.error) {
                    const errorCode = error.response.data.error;
                    
                    if (errorCode == "Request failed with status code 429" || errorCode === "RL1") {
                        setModalLimitLogin(true)
                    } else {
                        const message = getErrorMessage(errorCode);
                        setErrorMessage(message);
                        setErrorSubmit(false);
                        setTimeout(() => {
                            setErrorSubmit(true)
                            setErrorMessage('')
                        }, 5000)
                    }
                } else if (error == "Request failed with status code 429") {
                    setModalLimitLogin(true)
                } else {
                    setErrorMessage("Terjadi kesalahan. Silakan coba kembali.");
                    setErrorSubmit(false);
                    setTimeout(() => {
                        setErrorSubmit(true)
                        setErrorMessage('')
                    }, 5000)
                }
            });
        // } else {
        //     setModalReCAPTCHA(true)
        // }

    }

    const verifyOTP = () => {
        let data = JSON.stringify({
            "user_id": userID,
            "email": emailEncrypt,
            "name": namaEncrypt,
            "otp_code": otp
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_BASE_ENDPOINT_BACKEND}/peserta/verifikasiKodeOtpPeserta`,
            headers: { 
                'Content-Type': 'application/json'
            },
            data : data
        };

        axios.request(config)
            .then((response) => {

                if(response.status == 200) {
                    // Reset error states
                    setErrorOTP(true);
                    setErrorMessageOTP('');
                    
                    sessionStorage.setItem('user', JSON.stringify({id: userID, nama:namaEncrypt, email: emailEncrypt, id_Event: idEvent, token: response.token, api_key: response.token}));
                    window.location.href = '/p2';

                    setModalOTP(false);
                }
            })
            .catch((error) => {
                console.log(error);
                
                if (error.response && error.response.data && error.response.data.error) {
                    const errorCode = error.response.data.error;
                    const message = getErrorMessage(errorCode);
                    setErrorMessageOTP(message);
                    setErrorOTP(false);
                    setTimeout(() => {
                        setErrorOTP(true)
                        setErrorMessageOTP('')
                    }, 5000)
                } else {
                    setErrorMessageOTP("Terjadi kesalahan. Silakan coba kembali.");
                    setErrorOTP(false);
                    setTimeout(() => {
                        setErrorOTP(true)
                        setErrorMessageOTP('')
                    }, 5000)
                }
            });
    }

    // const warning = () => {
    //     const auth = JSON.parse(sessionStorage.getItem("user"));
    //     const data = JSON.stringify({
    //         "id": idPeserta,
    //         "soal": JSON.stringify(inputFields),
    //     });

    //     const config = {
    //         method: 'patch',
    //         url: `${process.env.REACT_APP_BASE_ENDPOINT_BACKEND}/peserta/updateSoal`,
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'x-api-key': auth.token
    //         },
    //         data: data
    //     };

    //     axios(config)
    //         .then(function (response) {
    //             window.location.href = '/p2'
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //         });

    // }

    useEffect(() => {

        if (!navigator.mediaDevices?.enumerateDevices) {
            console.log("enumerateDevices() not supported.");
        } else {
            navigator.mediaDevices.enumerateDevices().then(function (devices) {
                const cameraList = devices.filter((device) => device.kind === "videoinput");
                setCameras(cameraList);
            })
                .catch(function (err) {
                    console.log("Error Video Input", err);
                });

            navigator.mediaDevices.enumerateDevices().then(function (devices) {
                const audioList = devices.filter((device) => device.kind === "audioinput")
                setMics(audioList)
            })
                .catch(function (err) {
                    console.log("Error Audio Input", err);
                });
        }
        //   const hai = navigator.mediaDevices.getSupportedConstraints().echoCancellation;
    }, [])


    const handleChangeAudio = (event) => {
        setSelectedMicId(event.target.value);
        sessionStorage.setItem("Mic", event.target.value)
    };

    const handleChangeVideo = (event) => {
        setSelectedCameraId(event.target.value);
        sessionStorage.setItem("Camera", event.target.value)
    };

    return (
        <React.Fragment>
            <style>
                {`
                    @keyframes slideDown {
                        from {
                            opacity: 0;
                            transform: translateY(-10px);
                            max-height: 0;
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                            max-height: 100px;
                        }
                    }
                `}
            </style>
            <Row style={{ margin: '0px', height: '100vh', alignItems: 'center', fontFamily: "Nunito" }}>
                <Col md={12} lg={6} xl={6} style={{ height: '100%', padding: '0px' }}>
                    <img src={Welcome} style={{ height: '-webkit-fill-available' }} />
                </Col>

                <Col md={12} lg={6} xl={6} style={{ padding: '0px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                    <div style={{ display: 'flex', justifyContent: 'center', marginRight: '50px' }}>
                        <img src={logoTelkom} />
                    </div>

                    <div style={{ marginTop: '50px', padding: '25px', boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.08)', borderRadius: '8px', width: '65%', marginRight: '50px' }}>
                        {!errorSubmit && errorMessage && (
                            <Alert 
                                color="danger" 
                                style={{ 
                                    textAlign: 'center', 
                                    backgroundColor: '#FEE2E2', 
                                    color: '#DC2626', 
                                    borderColor: '#FCA5A5', 
                                    borderLeft: '4px solid #DC2626',
                                    margin: '10px 0px 20px 0px', 
                                    borderRadius: '6px',
                                    padding: '12px 16px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    animation: 'slideDown 0.3s ease-out',
                                    boxShadow: '0 2px 4px rgba(220, 38, 38, 0.1)'
                                }}
                                onClose={() => {
                                    setErrorSubmit(true);
                                    setErrorMessage('');
                                }}
                                toggle={() => {
                                    setErrorSubmit(true);
                                    setErrorMessage('');
                                }}
                            >
                                <i className="ri-error-warning-line" style={{ fontSize: '18px' }}></i>
                                {errorMessage}
                            </Alert>
                        )}
                        {!errorSubmitKonten && kontenError && (
                            <Alert 
                                color="danger" 
                                style={{ 
                                    textAlign: 'center', 
                                    backgroundColor: '#FEE2E2', 
                                    color: '#DC2626', 
                                    borderColor: '#FCA5A5', 
                                    borderLeft: '4px solid #DC2626',
                                    margin: '10px 0px 20px 0px', 
                                    borderRadius: '6px',
                                    padding: '12px 16px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    animation: 'slideDown 0.3s ease-out',
                                    boxShadow: '0 2px 4px rgba(220, 38, 38, 0.1)'
                                }}
                                onClose={() => {
                                    setErrorSubmitKonten(true);
                                    setKontenError('');
                                }}
                                toggle={() => {
                                    setErrorSubmitKonten(true);
                                    setKontenError('');
                                }}
                            >
                                <i className="ri-error-warning-line" style={{ fontSize: '18px' }}></i>
                                {kontenError}
                            </Alert>
                        )}

                        <div className="mb-3">
                            <Label htmlFor="kodeInterview" className="form-label">Email</Label>
                            <Input type="text" value={email} onChange={changeEmail} className="form-control" id="kodeInterview" placeholder="Masukkan Email" maxLength={60} required />
                            {errorEmail && (
                                <p style={{ margin: '0', color: '#F56565', fontSize: '10px', position: 'absolute' }}>{errorEmail}</p>
                            )}
                        </div>

                        <div className="mb-3">
                            <Label htmlFor="kodeInterview" className="form-label">Kode Intervieww</Label>
                            <Input type="text" value={kode} onChange={changeKode} className="form-control" id="kodeInterview" placeholder="Masukkan Kode Interview" maxLength={25} required />
                            {errorKode && (
                                <p style={{ margin: '0', color: '#F56565', fontSize: '10px', position: 'absolute' }}>{errorKode}</p>
                            )}
                        </div>

                        {/* <ReCAPTCHA sitekey={process.env.REACT_APP_SITE_KEY} ref={captchaRef} /> */}

                        <div className="mt-4">
                            <Button color="success" className="w-100" onClick={() => { loginKode() }} disabled={isDouble}>Masuk</Button>
                        </div>
                    </div>
                </Col>
            </Row>

            {/* ------- MODAL WARNING ------- */}
            {/* <Modal isOpen={modalWarning} toggle={() => { }} centered>
                <ModalBody style={{ display: "flex", flexDirection: "column", alignItems: "center", overflow: "auto", fontFamily: 'Nunito' }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <h5 style={{ textAlign: "center", padding: "0 70px", margin: '50px 0px' }}>
                            Silahkan Masuk
                        </h5>
                        <Button color='success' onClick={() => { warning() }}>Masuk</Button>
                    </div>
                </ModalBody>
            </Modal> */}

            <Modal isOpen={sambutan} toggle={() => { }} size="lg" centered>
                <ModalBody style={{ display: "flex", flexDirection: "column", alignItems: "center", fontFamily: 'Nunito' }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <h5 style={{ textAlign: "center", padding: "0 70px", margin: '30px 0px', fontSize: '24px' }}>
                            Selamat Datang di Web Interview Telkom ACI
                        </h5>
                        <p style={{ fontSize: '16px', textAlign: 'justify', padding: "0px 70px" }}>Pastikan kembali perangkat anda, karena di Web Interview Telkom ACI ada Proses pengambilan video dan audio. Pastikan memberi akses izin Video dan Audio untuk merekam, jika belum terlihat video di layar anda silahkan Refresh Page ini</p>
                        <Webcam
                            style={{
                                borderRadius: "10px",
                                boxShadow: "0px 2px 5px #0000001a, 0px 0px 2px #00000033",
                            }}
                            width="480"
                            height="360"
                            audioConstraints={{ echoCancellation: false, deviceId: selectedMicId }}
                            videoConstraints={{ deviceId: selectedCameraId }}
                            audio={true}
                            ref={webcamRef}
                            muted={bersuara}
                        />
                        <Button style={{ fontSize: '16px', marginTop: '20px' }} color={bersuara == true ? "warning" : "success"} onClick={() => { setBersuara(!bersuara) }}>
                            {bersuara == true ? "Sound OFF" : "Sound ON"}
                        </Button>
                        <label style={{ fontSize: '14px' }}>Pilih Webcam:</label>
                        <select
                            style={{ fontSize: '14px' }}
                            value={selectedCameraId}
                            onChange={(event) => {
                                handleChangeVideo(event);
                            }}
                            disabled={disablerChoose}
                        >
                            {cameras.map((camera) => (
                                <option key={camera.deviceId} value={camera.deviceId}>
                                    {camera.label}
                                </option>
                            ))}
                        </select>
                        <label style={{ fontSize: '14px' }}>Pilih Microphone:</label>
                        <select
                            style={{ fontSize: '14px' }}
                            value={selectedMicId}
                            onChange={(event) => {
                                handleChangeAudio(event);
                            }}
                            disabled={disablerChoose}
                        >
                            {mics.map((device) => (
                                <option key={device.deviceId} value={device.deviceId}>
                                    {device.label}
                                </option>
                            ))}
                        </select>
                        <Button style={{ fontSize: '16px', marginTop: '20px' }} color='success' onClick={() => { setSambutan(false) }}>Sudah terlihat jelas</Button>
                    </div>
                </ModalBody>
            </Modal>

            <Modal isOpen={modalLimitLogin} toggle={() => { }} centered>
                <ModalBody style={{ display: "flex", flexDirection: "column", alignItems: "center", overflow: "auto" }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <h5 style={{ textAlign: "center", padding: "0 50px", margin: '50px 0px' }}>
                            Terlalu banyak melakukan percobaan,<br />Mohon tunggu beberapa menit
                        </h5>
                        <Button color="success" onClick={() => { setModalLimitLogin(false) }}>Oke Deh</Button>
                    </div>
                </ModalBody>
            </Modal>

            {/* ------- MODAL CAPTCHA ------- */}
            {/* <Modal isOpen={modalReCAPTCHA} toggle={() => { }} centered>
                <ModalBody style={{ display: "flex", flexDirection: "column", alignItems: "center", overflow: "auto" }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <h5 style={{ textAlign: "center", padding: "0 70px", margin: '50px 0px' }}>
                            reCAPTCHA dulu kawan
                        </h5>
                        <Button color="success" onClick={() => { setModalReCAPTCHA(false) }}>Oke Deh</Button>
                    </div>
                </ModalBody>
            </Modal> */}
            <Modal isOpen={modalOTP} toggle={() => { }} centered>
                <ModalBody style={{ display: "flex", flexDirection: "column", alignItems: "center", overflow: "auto", padding: '30px' }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: '100%' }}>
                        <p style={{fontWeight: '700', fontSize: '30px', color: '#F56565', textAlign: 'center', marginBottom: '20px'}}>Verifikasi OTP</p>

                        {!errorOTP && errorMessageOTP && (
                            <Alert 
                                color="danger" 
                                style={{ 
                                    textAlign: 'center', 
                                    backgroundColor: '#FEE2E2', 
                                    color: '#DC2626', 
                                    borderColor: '#FCA5A5', 
                                    borderLeft: '4px solid #DC2626',
                                    margin: '0px 0px 20px 0px', 
                                    borderRadius: '6px',
                                    padding: '12px 16px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    width: '100%',
                                    animation: 'slideDown 0.3s ease-out',
                                    boxShadow: '0 2px 4px rgba(220, 38, 38, 0.1)'
                                }}
                                onClose={() => {
                                    setErrorOTP(true);
                                    setErrorMessageOTP('');
                                }}
                                toggle={() => {
                                    setErrorOTP(true);
                                    setErrorMessageOTP('');
                                }}
                            >
                                <i className="ri-error-warning-line" style={{ fontSize: '18px' }}></i>
                                {errorMessageOTP}
                            </Alert>
                        )}

                        <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                            <ReactInputVerificationCode value={otp} onChange={(value) => {
                                setOTP(value);
                                // Reset error when user starts typing
                                if (errorMessageOTP) {
                                    setErrorOTP(true);
                                    setErrorMessageOTP('');
                                }
                            }}/>
                        </div>
                        
                        <p style={{textAlign: 'center', marginTop: '20px', fontSize: '14px'}}> 
                            Anda masuk belum menerima kode? 
                            <span style={{fontWeight: '700', fontSize: '16px', color: '#F56565', cursor: 'pointer', marginLeft: '4px'}} onClick={() => {
                                setErrorOTP(true);
                                setErrorMessageOTP('');
                                loginKode();
                                }}>Kirim Ulang</span>
                        </p>
                        
                        <div className="text-center mt-2" style={{width: '100%'}}>
                            <Button style={{fontSize: '14px'}} color="success" className="w-100" onClick={() => {
                                verifyOTP();
                                // onNext(); 
                                }}>
                                Verifikasi
                            </Button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>

        </React.Fragment>
    );
};

export default CoverSignIn;